import Tooltip from "components/Tooltip";
import { Checkbox } from "design_system";
import { Paper } from "helpers/api";
import useLabels from "hooks/useLabels";
import { useAppDispatch, useAppSelector } from "hooks/useStore";
import {
  addSource,
  MAX_PAPER_SOURCES,
  removeSource,
  selectCanAddSource,
  selectSources,
} from "store/slices/sources";

type SearchResultSourceCheckboxProps = {
  paper: Paper;
};

function SearchResultSourceCheckbox({
  paper,
}: SearchResultSourceCheckboxProps) {
  const [tooltipLabels] = useLabels("features.threads.data-source-selector");

  const dispatch = useAppDispatch();
  const sources = useAppSelector(selectSources);
  const canAddSource = useAppSelector(selectCanAddSource);

  const isSource = sources.some((source) => source.paper_id === paper.paper_id);

  const handleClick = () => {
    if (isSource) {
      dispatch(removeSource(paper.paper_id));
    } else if (canAddSource) {
      dispatch(addSource(paper));
    }
  };

  if (!canAddSource && !isSource) {
    return (
      <Tooltip
        content={
          <div className="text-center">
            {tooltipLabels["up-to-X-sources"].replace(
              "{MAX_SOURCES}",
              MAX_PAPER_SOURCES
            )}
          </div>
        }
        placement="right"
      >
        <div
          onClick={(e: React.MouseEvent<HTMLDivElement>) => {
            e.stopPropagation(); // Don't propagate click event to SearchResult to avoid triggering search result click
          }}
        >
          <Checkbox isChecked={isSource} onClick={handleClick} isDisabled />
        </div>
      </Tooltip>
    );
  }

  return (
    <Tooltip
      content={isSource ? "Remove from input" : "Add to input"}
      delay={500}
      placement="right"
    >
      <div
        className="relative"
        onClick={(e: React.MouseEvent<HTMLDivElement>) => {
          e.stopPropagation(); // Don't propagate click event to SearchResult to avoid triggering search result click
        }}
      >
        {/* Bigger area to catch clicks on the checkbox and make it easier to click */}
        <div
          className="absolute -inset-1.5 cursor-pointer"
          onClick={handleClick}
        />
        <Checkbox isChecked={isSource} readOnly />
      </div>
    </Tooltip>
  );
}

export default SearchResultSourceCheckbox;
